<template>
    <div class="pta-admin">
        <div class="page-titles border-bottom">
            <h3>Bio Test</h3>
            <button class="btn btn-info btn-sm pull-right" @click="$router.push('/account/transcripts')"><i class="fas fa-list"></i> <span class="d-none d-sm-inline">{{trans('bio.bio_list')}}</span></button>
        </div>
        <div class="container-fluid p-0" style="font-size: 0.75em;">
          <div style="width:50%;float:left">
            <div class="row" style="background:#fff;border-radius:20px;padding:20px 20px 40px;">
            <div class="col-12 col-sm-12">
                <div class="row">
                  <div class="col-12 col-sm-12">
                    <div class="form-group">
                      <label for="">Name<span style="font-size:12px;display:inline-block;padding-left:10px;">(e.g. John Doe)</span></label>
                      <input class="form-control" type="text" value="" v-model="bioForm.name" name="name" />
                    </div>
                  </div>
                  <div class="col-12 col-sm-12">
                    <div class="form-group">
                      <label for="">Title<span style="font-size:12px;display:inline-block;padding-left:10px;">(e.g. Senior Developer)</span></label>
                      <input class="form-control" type="text" value="" v-model="bioForm.title" name="title" />
                    </div>
                  </div>
                  <div class="col-12 col-sm-12">
                    <div class="form-group">
                      <label for="">Company<span style="font-size:12px;display:inline-block;padding-left:10px;">(e.g. Tech Solutions)</span></label>
                      <input class="form-control" type="text" value="" v-model="bioForm.company" name="company" />
                    </div>
                  </div>
                  <div class="col-12 col-sm-12">
                    <div class="form-group">
                      <label for="">Company headquarter<span style="font-size:12px;display:inline-block;padding-left:10px;">(e.g. San Francisco, USA)</span></label>
                      <input class="form-control" type="text" value="" v-model="bioForm.company_hq" name="company_hq" />
                    </div>
                  </div>
                  <div class="col-12 col-sm-12">
                    <div class="form-group">
                      <label for="">Investor type<span style="font-size:12px;display:inline-block;padding-left:10px;">(e.g. Institutional Investor)</span></label>
                      <input class="form-control" type="text" value="" v-model="bioForm.investor_type" name="investor_type" />
                    </div>
                  </div>
                  <div class="col-12 col-sm-12">
                    <div class="form-group">
                      <label for="">Investor country<span style="font-size:12px;display:inline-block;padding-left:10px;">(e.g. USA)</span></label>
                      <input class="form-control" type="text" value="" v-model="bioForm.investor_country" name="investor_country" />
                    </div>
                  </div>
                  <div class="col-12 col-sm-12">
                    <div class="form-group">
                      <label for="">Asset class<span style="font-size:12px;display:inline-block;padding-left:10px;">(e.g. Technology)</span></label>
                      <input class="form-control" type="text" value="" v-model="bioForm.asset_class" name="asset_class" />
                    </div>
                  </div>
                  <div class="col-12 col-sm-12">
                    <div class="form-group" style="margin-bottom: 30px;">
                      <label for="">Investment location<span style="font-size:12px;display:inline-block;padding-left:10px;">(e.g. Global)</span></label>
                      <input class="form-control" type="text" value="" v-model="bioForm.investment_location" name="investment_location" />
                    </div>
                  </div>
                  <div class="col-12 col-sm-12">
                    <button v-if="!is_run" type="button" @click.prevent="sendText" class="btn btn-info">Start Bio Generation</button>
                    <button v-if="is_run" type="button" @click.prevent="resetText" class="btn btn-info">Reset</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div style="width:50%;float:left;padding:0 0 0 40px;">
            <div style="background:#fff;border-radius:20px;padding:40px;min-height:400px;">
              <div v-if="is_run">
                <img src="/images/11-38-42-66_512.webp" style="max-width:400px;width:80%;margin:50px auto 0;opacity:0.2;display:block;" />
                <center>The AI process is running. Please wait.</center>
              </div>
              <div v-if="is_ready" class="pta-ai-results">
                <div v-text="bio"></div>
              </div>
            </div>

          </div>
          <div style="clear:left"></div>
        </div>
    </div>
</template>
<script>
    export default {
        components : {  },
        data() {
            return {
              bioForm: new Form({
                name: '',
                title: '',
                company: '',
                company_hq: '',
                investor_type: '',
                investor_country: '',
                asset_class: '',
                investment_location: '',
              },false),
              bioError: {
                error: '',
              },
              is_run: false,
              is_ready:false,
              uuid: '',
              bio: ''
            };
        },
        mounted(){
         // this.uuid = 'bb346ff3-de6e-45ae-a33f-9f0fbf661705';
        //  this.getValues();
        },
        methods: {
          sendText(){
             this.bio = '';
             this.is_ready = false;
             this.is_run = true;
             this.bioForm.post('/api/aws/bio-test')
                 .then(response => {
                    console.log(response.bio);
                    this.bio = response.bio;
                    this.is_run = false;
                    this.is_ready = true;
                  })
                  .catch(error => {
                    helper.showErrorMsg(error);
                  });
          },
          resetText(){
            this.is_run = false;
            this.bioForm.reset();
          }
        },
        filters: {

        }
    }
</script>
<style>
.pta-ai-results table td{
  font-size:0.8em;
  line-height:1.25em;
  padding:8px;
  vertical-align:top;
}
.pta-ai-results table tr:nth-child(odd){
  background:#efefef;
}
</style>
